import { Component, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-direkt-virtual-tour',
  templateUrl: './direkt-virtual-tour.component.html',
  styleUrls: ['./direkt-virtual-tour.component.css']
})
export class DirektVirtualTourComponent {

  constructor(
    public shared: SharedService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    public apiService: ApiServiceService,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
  }
}
